import * as pageContentActionTypes from './pageContentActionTypes';

export const hideShowMenu = payload => ({
    type: pageContentActionTypes.HIDE_SHOW_MENU,
    data: payload
});
